
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlJ as ObiOwnShipControlJElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-j.js';
 
 
 

 
 export const ObiOwnShipControlJ = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-j',
   elementClass: ObiOwnShipControlJElement,
   events: {
     
   }
  });
 
 